import { render } from "./TestResultContent.vue?vue&type=template&id=4ae95ddc&scoped=true"
import script from "./TestResultContent.vue?vue&type=script&lang=js"
export * from "./TestResultContent.vue?vue&type=script&lang=js"

import "./TestResultContent.vue?vue&type=style&index=0&id=4ae95ddc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae95ddc"]])

export default __exports__